import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperBuySocialPayScanConfirmPage } from './shopper-buy-social-pay-scan-confirm';

@NgModule({
  declarations: [
    ShopperBuySocialPayScanConfirmPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperBuySocialPayScanConfirmPage),
    TranslateModule.forChild()
  ],
})
export class ShopperBuySocialPayScanConfirmPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-social-pay-scan-confirm/shopper-buy-social-pay-scan-confirm.module.ts